export const initSaveRecipes = () => {
  /**
   * Following code makes it possible to save/remove and interact with saved recipes through both recipe-puffs, recipe-archive, all recipe-category and recipe-pages.
   */
  interface Recipe {
    name: string;
    url: string;
    image: string;
  }

  // Get all recipe elements on the page
  const recipeElements: NodeListOf<HTMLDivElement> = document.querySelectorAll('.recipe');

  // Initialize saved recipes from local storage or an empty array
  let savedRecipes: Recipe[] = JSON.parse(localStorage.getItem('savedRecipes')) || [];

  // Check if a recipe is saved
  const isRecipeSaved = (recipeName: string): boolean => {
    return savedRecipes.some((recipe) => recipe.name === recipeName);
  };

  // Save or unsave a recipe
  const toggleSaveRecipe = (recipeData: Recipe): void => {
    const index: number = savedRecipes.findIndex((recipe) => recipe.name === recipeData.name);
    if (index === -1) {
      savedRecipes.push(recipeData);
    } else {
      savedRecipes.splice(index, 1);
    }
    localStorage.setItem('savedRecipes', JSON.stringify(savedRecipes));
  };

  // Update the heart button class
  const updateHeartButtonClass = (heartButton: HTMLButtonElement, isSaved: boolean): void => {
    heartButton.classList.toggle('recipe--saved', isSaved);
  };

  // Reset the heart button on the current page
  const resetHeartButton = (recipeName: string, isSaved: boolean): void => {
    const recipeElement = document.querySelector(`.recipe[data-recipe-name="${recipeName}"]`);
    if (recipeElement) {
      const heartButton: HTMLButtonElement | null = recipeElement.querySelector('.heart-button') as HTMLButtonElement | null;
      if (heartButton) {
        updateHeartButtonClass(heartButton, isSaved);
      }
    }
  };

  // Remove a saved recipe
  const removeSavedRecipe = (recipeName: string): void => {
    const index: number = savedRecipes.findIndex((recipe) => recipe.name === recipeName);
    if (index !== -1) {
      savedRecipes.splice(index, 1);
      localStorage.setItem('savedRecipes', JSON.stringify(savedRecipes));
      displaySavedRecipes();
      isAnySaved();

      // Reset the heart button on the current page
      resetHeartButton(recipeName, false);
    }
  };

  // Create and attach a remove button to a saved recipe item
  const createRemoveButton = (recipeName: string): HTMLButtonElement => {
    const removeButton: HTMLButtonElement = document.createElement('button');
    removeButton.textContent = '';
    removeButton.classList.add('remove-button');
    removeButton.classList.add('recipe--saved');
    removeButton.addEventListener('click', () => {
      removeSavedRecipe(recipeName);
      isAnySaved();
    });
    return removeButton;
  };

  // Display saved recipes in the "Saved Recipes" section
  const displaySavedRecipes = (): void => {
    const savedRecipeList: HTMLUListElement | null = document.getElementById('saved-recipe-list') as HTMLUListElement | null;
    if (!savedRecipeList) return;

    savedRecipeList.innerHTML = '';
    savedRecipes.forEach((recipe) => {
      // Create list items for each saved recipe
      const listItem: HTMLLIElement = document.createElement('li');
      const article: HTMLElement = document.createElement('article');

      article.classList.add('saved-recipe-item');

      // Create HTML to display saved recipes
      article.innerHTML = `
        <a class="wrapper-link" href="${recipe.url}" target="_blank">
          <picture class="picture">
            <img src="${recipe.image}" alt="${recipe.name}">
          </picture>
          <section class="heading-wrapper">
            <h3 class="recipe-heading">${recipe.name}</h3>
          </section>
        </a>
      `;

      // Create and attach the remove button
      const removeButton: HTMLButtonElement = createRemoveButton(recipe.name);
      article.appendChild(removeButton); // Append Remove Button to Article

      listItem.appendChild(article); // Append Article to List Item

      savedRecipeList.appendChild(listItem);

      isAnySaved();
    });
  };

  // Add click event listeners to the recipe elements
  recipeElements.forEach((recipeElement) => {
    const heartButton: HTMLButtonElement | null = recipeElement.querySelector('.heart-button') as HTMLButtonElement | null;
    if (!heartButton) return;

    const recipeName: string | null = recipeElement.getAttribute('data-recipe-name');
    if (!recipeName) return;

    // Check if the recipe is saved and update the heart button class
    const isSaved: boolean = isRecipeSaved(recipeName);
    updateHeartButtonClass(heartButton, isSaved);

    heartButton.addEventListener('click', () => {
      const recipeData: Recipe = {
        name: recipeName,
        url: recipeElement.getAttribute('data-recipe-url') || '',
        image: recipeElement.getAttribute('data-recipe-image') || '',
      };
      toggleSaveRecipe(recipeData);
      updateHeartButtonClass(heartButton, isRecipeSaved(recipeName));
      displaySavedRecipes();
      isAnySaved();
    });
  });

  const isAnySaved = () => {
    /**
   * Modify heart on Toggle saved Recipes
   */
    const openSavedRecipesButton: HTMLButtonElement = document.querySelector(".toggle-saved-recipies");
    if (savedRecipes.length > 0) {
      openSavedRecipesButton.classList.add("contains-saved-recipes");
    } else {
      openSavedRecipesButton.classList.remove("contains-saved-recipes");
    }
  }

  // Display saved recipes initially
  displaySavedRecipes(); 
};